import { observer } from 'mobx-react-lite';
import { useContent } from '@/stores/RootStore';
import { useReveal } from '@/hooks/useReveal';
import SectionHeader from '@/components/ui/SectionHeader';
import LogoCarousel from '@/components/ui/LogoCarousel';
import s from './Trust.module.scss';

// 인증 · 협력 기관 — 공통 SectionHeader + 공통 LogoCarousel(스텝 캐러셀).
//   캐러셀 로직/스타일은 components/ui/LogoCarousel 로 추출(Clients와 공용, 2026-07-31).
const Trust = observer(() => {
  const { trust } = useContent();
  const reveal = useReveal<HTMLDivElement>();
  return (
    <section className={s.section}>
      <div className={s.inner} ref={reveal}>
        <SectionHeader title={trust.title} tagline={trust.tagline} divider className="anim-scroll" />
        <LogoCarousel logos={trust.partners} />
      </div>
    </section>
  );
});

export default Trust;
